import { ReactElement } from 'react'
import IFCTransparencyControls from '@editor/components/Controls/IFCControls/IFCTransparencyControls'
import { PopoverPanel } from '@ui2/structure'

interface Props {
  anchorEl: HTMLElement | null
  onClose: () => void
}

/**
 * Settings popover for the IFC storey controls (opened from the header gear icon). Lets the user
 * make the IFC/GLB model transparent and set its opacity, mirroring the "Planbereich" popover.
 */
const IFCSettingsPopover = ({ anchorEl, onClose }: Props): ReactElement => (
  <PopoverPanel anchorEl={anchorEl} onClose={onClose} title="IFC" dataCy="ifc-settings-popover">
    <IFCTransparencyControls />
  </PopoverPanel>
)

export default IFCSettingsPopover
